//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ShowMediaAsset from "@/components/common/ShowMediaAsset";
import UiLazyImg from "@/components/Ui/UiLazyImg.vue";

export default {
  name: "ReviewCard",
  components: {
    ShowMediaAsset,
    UiLazyImg
  },
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      dialog: false,
      dialogItem: null,
      expanded: false,
      showExpandedBtn: false,
      dotInstance: null,
      noImageFile: {
        url: '/images/no-image.webp',
        media_type: 'image/webp'
      }
    }
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.dialogItem = null;
      }
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width <= 920;
    },
    isVideo() {
      return this.mediaFile?.media_type?.includes('video');
    },
    mediaFile() {
      return this.info?.medias?.[0]?.file || this.noImageFile;
    },
    hasMedia() {
      return this.info?.medias?.[0]?.file?.url;
    }
  },
  methods: {
    toggleExpanded() {
      this.expanded ? this.dotInstance?.API?.truncate() : this.dotInstance?.API?.restore();
      this.expanded = !this.expanded;
      if (this.isMobile && !this.expanded) {
        this.$nextTick(() => {
          this.$refs?.description?.scrollIntoView({ block: "center" });
        })
      }
      this.$nextTick(() => {
        this.dotInit();
      })
    },
    dotInit() {
      if (this.dotInstance) {
        this.dotInstance.container?.dotdotdot?.destroy();
      }
      const Dotdotdot = require("dotdotdot-js")?.default;
      let dotSelector = this.$el.querySelector('.dotdotdot');
      if (Dotdotdot && dotSelector) {
        this.dotInstance = new Dotdotdot( dotSelector, { callback: this.dotCallback });
      }
    },
    dotCallback(e) {
      this.showExpandedBtn = e;
    },
    openDialog() {
      if (!this.hasMedia) {
        return;
      }
      this.dialogItem = this.mediaFile;
      this.dialog = true;
    }
  },
  async mounted() {
    this.dotInit();
  }
}
